import * as consts from './ListingsConsts';

const initialState = {
    listingsList: []
};

const listings = (state = initialState, action) => {
    switch (action.type) {
        case consts.GET_LISTINGS_FULFILLED:
            return {
                ...state,
                listingsList: action.payload.listings || [],
            }
        default:
            return state
    }
}

export default listings;
